<template>
  <v-card outlined :loading="loading">
    <v-card-title>
      DUPLICACIONES
      <v-spacer/>
<!--      <v-btn-->
<!--          color="primary"-->
<!--          @click="consultaShow()"-->
<!--      >-->
<!--        Consulta-->
<!--      </v-btn>-->
      <v-btn
          color="primary"
          class="ml-2"
          @click="openConsumoAgua()"
      >
        + Duplicar factura de consumo de agua
      </v-btn>
      <v-btn
          color="accent"
          class="ml-2"
          @click="openOtroIngreso()"
      >
        + Duplicar factura de otros ingresos
      </v-btn>
    </v-card-title>
    <v-divider/>
    <v-card-text>
      <span>Duplicaciones realizadas el día de <strong>hoy</strong></span>
      <v-btn
          color="secundary"
          class="ml-2"
          outlined
          title="Actualizar lista"
          @click="listar()"
      >
        <v-icon>mdi-update</v-icon>
      </v-btn>

      <v-data-table
          :headers="headers"
          :items="duplicaciones"
          class="mt-5"
          hide-default-footer
          disable-pagination
      >
        <template v-slot:item.numero="{ index }">
          {{ index + 1 }}
        </template>
        <template v-slot:item.factura="props">
          <div  v-if="props.item.cobranza">
            Nro. Factura: <strong>{{ props.item.cobranza.numero_factura }}</strong> <br>
            nfac: {{ props.item.cobranza.nfac }}
          </div>
          <div v-else>
            nfac: {{props.item.nfac }}
          </div>
        </template>
        <template v-slot:item.fecha="props">
          {{ props.item.fecha | localDateHour }}
        </template>
        <template v-slot:item.fechaFactura="props">
          <div v-if="props.item.cobranza">
            {{ props.item.cobranza.fecha | localDateHour }}
          </div>
          <div v-else>
            {{ props.item.fecha | localDateHour }}
          </div>
        </template>
        <template v-slot:item.cliente="props">
          <div v-if="props.item.cobranza">
            Cuenta: {{ props.item.cobranza.cuenta }} <br>
            Ci/Nit: {{ props.item.cobranza.ci_nit }} <br>
            Razon Social: {{ props.item.cobranza.razon_social }}
          </div>
          <div v-else>
            Cuenta: {{ props.item.cuenta }} <br>
          </div>
        </template>
        <template v-slot:item.cobranza.tipo="props">
          {{ props.item.cobranza ? props.item.cobranza.tipo : 'ConsumoAgua' }}
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="isNewOtroIngreso" persistent max-width="500px">
      <duplicacion-otro-ingreso @close="closeOtroIngreso()"/>
    </v-dialog>
    <v-dialog v-model="consultaDialog"  max-width="500px">
      <consulta @close="closeConsulta()"/>
    </v-dialog>
    <v-dialog v-model="isNewConsumoAgua" persistent max-width="500px">
      <duplicacion-consumo-agua @close="closeConsumoAgua()"/>
    </v-dialog>
  </v-card>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import {duplicacionStore} from "@/store/duplicacionStore";
import DuplicacionOtroIngreso from "@/views/duplicaciones/DuplicacionOtroIngreso.vue";
import {Duplicacion} from "@/models/Duplicacion";
import {DuplicacionService} from "@/services/DuplicacionService";
import DuplicacionConsumoAgua from "@/views/duplicaciones/DuplicacionConsumoAgua.vue";
import Consulta from "@/views/duplicaciones/Consulta.vue";
import moment from "moment";

@Component({
  name: "DuplicacionIndex",
  components: {DuplicacionConsumoAgua, DuplicacionOtroIngreso, Consulta}
})
export default class DuplicacionIndex extends Vue {
  private duplicacionStore = duplicacionStore();
  private duplicacionService = DuplicacionService.getInstance();
  private consultaDialog = false;
  private headers = [
    {text: "#", value: "numero"},
    {text: "Fecha Duplicado", value: "fecha"},
    {text: "Fecha Factura", value: "fechaFactura"},
    {text: "Número Factura", value: "factura"},
    {text: "Cliente", value: "cliente"},
    {text: "Motivo", value: "descripcion"},
    {text: "Tipo", value: "cobranza.tipo"},
  ]
  closeConsulta() {
    this.consultaDialog = false;
  }

  consultaShow() {
    this.consultaDialog = true;
  }

  get loading(): boolean {
    return this.duplicacionStore.loading;
  }

  get duplicaciones(): Duplicacion[] {
    return this.duplicacionStore.duplicaciones;
  }

  get isNewOtroIngreso(): boolean {
    return this.duplicacionStore.isNewOtroIngreso;
  }

  get isNewConsumoAgua(): boolean {
    this.duplicacionStore.fechaHora = moment().format('YYYY-MM-DD HH:mm:ss');
    return this.duplicacionStore.isNewConsumoAgua;
  }

  mounted() {
    this.listar();
  }

  listar() {
    this.duplicacionService.index();
  }

  openOtroIngreso() {
    this.duplicacionStore.isNewOtroIngreso = true;
  }

  closeOtroIngreso() {
    this.duplicacionStore.isNewOtroIngreso = false;
  }

  openConsumoAgua() {
    this.duplicacionStore.isNewConsumoAgua = true;
  }

  closeConsumoAgua() {
    this.duplicacionStore.isNewConsumoAgua = false;
  }
}
</script>

<style scoped>

</style>